import Axios from 'axios'
import authHeader from '../helpers/auth-header.js'
import * as constants from '../helpers/Constants.js'
import Models from '@/store/ORM/models.js';

// const apiClient = Axios.create({
//   baseURL:constants.APIURL,
//   withCredentials: false, 
//   headers: {
//     Accept: 'application/json',
//     'Content-Type': 'application/json',
//     'Authorization': 'Token ' + localStorage.getItem('token')
//   }
// })

var apiClient = Axios.create({
  baseURL:constants.APIURL,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
})

var apiClientFile = Axios.create({
  baseURL:constants.APIURL,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
})


apiClient.interceptors.response.use((response) =>{
  return response
},  (error) =>{
  if (error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('loggedin');
      localStorage.removeItem('vuex');

      
      Models.Reference.deleteAll();
      Models.Supplier.deleteAll();
      Models.Specialist.deleteAll();
      Models.CreatedMenu.deleteAll();
      Models.Specialist.deleteAll();
      Models.Nutritionist.deleteAll();
      Models.Client.deleteAll();
      Models.Event.deleteAll();
      Models.Product.deleteAll();

      let urls = window.location.href.split('#');
      window.open(urls[0],'_self');
  }
  return Promise.reject(error)
})


apiClientFile.interceptors.response.use((response) =>{
  console.log(response);
  return response
},  (error) =>{
  if (error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('loggedin');
      localStorage.removeItem('vuex');

      
      Models.Reference.deleteAll();
      Models.Supplier.deleteAll();
      Models.Specialist.deleteAll();
      Models.CreatedMenu.deleteAll();
      Models.Specialist.deleteAll();
      Models.Nutritionist.deleteAll();
      Models.Client.deleteAll();
      Models.Event.deleteAll();
      Models.Product.deleteAll();
      
      let urls = window.location.href.split('#');
      window.open(urls[0],'_self');
  }
  return Promise.reject(error)
})


export default {

  setAxios(){
    apiClient = Axios.create({
      baseURL:constants.APIURL,
      withCredentials: false, // This is the default
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    });
    apiClientFile = Axios.create({
      baseURL:constants.APIURL,
      withCredentials: false, // This is the default
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    });
  },
  get(endpoint){
     return apiClient.get(endpoint);
  },
  post(endpoint,body) {
    return apiClient.post(endpoint,body);
  },
  put(endpoint,body) {
    return apiClient.put(endpoint,body);
  },
  delete(endpoint) {
    return apiClient.delete(endpoint);
  },
  postFile(endpoint,body){
    return apiClientFile.post(endpoint,body);
  }
}